import { render } from "./PRO_Categorii.vue?vue&type=template&id=94d07ad2&ts=true"
import script from "./PRO_Categorii.vue?vue&type=script&lang=ts"
export * from "./PRO_Categorii.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__